const funcs = {
	toTimeFormatQuotes(times = '0') {
		let timeInt = parseInt(times);

		return `${parseInt(timeInt/60)}时${timeInt%60}分`;
	},
	toTimeFormatYmdhms(date = new Date(date)) {
		date = new Date(date)
		return `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
	}
}

function funcMap(args = []) {
	let map = []
	for (let key in funcs) args.indexOf(key) > -1 && (map[key] = funcs[key])
	return map
}

export default {
	//去掉 时间最后多出来的.0
	delLastTime0(val) {
		if (val) {
			return val.replace(/.[0-9]*$/, '')
		}
	},
	//标准时间格式化
	dateFormater(val) {
		var d = new Date(val);
		return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
	},
	//获取时间的年月日
	getYear_Month_Day(val) {
		var d = new Date(val);
		return d.getFullYear() + '年' + (d.getMonth() + 1) + '月' + d.getDate() + '日'
	},
	//获取当前时间
	getTime() {
		return this.dateFormater(new Date())
	},
	GetTimeAddYears(val) {
		let d1 = new Date();
		d1.setFullYear(d1.getFullYear() + val);
		d1.setDate(d1.getDate() - val);
		return d1
	},
	getTimeStamp() {
		return new Date().getTime()
	},
	//时间戳转时间格式
	timeStamp_dateFormater(formater, t) {
		let date = t ? new Date(t) : new Date(),
			Y = date.getFullYear() + '',
			M = date.getMonth() + 1,
			D = date.getDate(),
			H = date.getHours(),
			m = date.getMinutes(),
			s = date.getSeconds();
		return formater.replace(/YYYY|yyyy/g, Y)
			.replace(/YY|yy/g, Y.substr(2, 2))
			.replace(/MM/g, (M < 10 ? '0' : '') + M)
			.replace(/DD/g, (D < 10 ? '0' : '') + D)
			.replace(/HH|hh/g, (H < 10 ? '0' : '') + H)
			.replace(/mm/g, (m < 10 ? '0' : '') + m)
			.replace(/ss/g, (s < 10 ? '0' : '') + s).replace(' ', 'T')
	},
	// 考试倒计时 秒 转  分:秒
	exam_viewTime(val, fg) {
		if (!fg) {
			fg = ':'
		}

		let mm = 0
		if (val >= 60) {
			mm = parseInt(val / 60)
		}
		let ss = val % 60

		if (fg == ':') {
			if (ss < 10) {
				return mm + ' ' + fg + ' 0' + ss
			}
			return mm + fg + ss
		} else {
			if (ss < 10) {
				return mm + '′0' + ss + '″'
			}
			return mm + '′' + ss + '″'
		}
	},
	// 考试倒计时 秒 转  x分x秒
	exam_viewTime_ch(val) {
		if (val == 0||!val) {
			return 0
		}

		if (val > 0) {
			val = parseInt(val)
		}
		let mm = 0
		if (val >= 60) {
			mm = parseInt(val / 60)
		}
		let ss = val % 60
		if (ss < 10) {
			return mm + '分0' + ss + '秒'
		}
		return mm + '分' + ss + '秒'
	},
	// 考试倒计时 秒 转  x小时x分s秒
	exam_viewTime_ch_hh_mm(val) {
		let hh = 0
		let mm = 0
		let s = 0

		if (val >= 3600) {
			hh = parseInt(val / 3600)
		}

		let ss = val % 3600

		if (ss >= 60) {
			s = ss % 60
			mm = parseInt(ss / 60)
			if (mm < 10) {
				return hh + '小时0' + mm + '分' + s + '秒'
			}
		} else {
			s = ss
		}
		return hh + '小时' + mm + '分' + s + '秒'
	},
	// 00:00:00
	exam_viewTime_ch_hh_mm1(val) {
		let hh = 0
		let mm = 0
		let s = 0
		if (val >= 3600) {
			hh = parseInt(val / 3600)
		}
		let ss = val % 3600
		if (ss >= 60) {
			s = ss % 60
			mm = parseInt(ss / 60)
		} else {
			s = ss
		}

		if (hh < 10) {
			hh = '0' + hh
		}

		if (mm < 10) {
			mm = '0' + mm
		}
		if (s < 10) {
			s = '0' + s
		}
		return hh + ':' + mm + ':' + s
	},
	//秒 转 xx小时xx分
	s_to_hh_mm(val) {
		let hh = 0
		let mm = 0
		if (val >= 3600) {
			hh = parseInt(val / 3600)
		}
		let ss = val % 3600
		if (ss >= 60) {
			mm = parseInt(ss / 60)
			if (mm < 10) {
				return hh + '小时0' + mm + '分'
			}
		}
		return hh + '小时' + mm + '分'
	},
	//计算两个时间的时间差，返回时间格式（分秒）
	//返回时间格式：x′x″ 
	math_A_B(a, b) {
		let _a = new Date(a)
		let _b = new Date(b)
		let _c = _b.getTime() - _a.getTime()
		return this.exam_viewTime(_c / 1000)
	},
	//计算两个时间的差值，返回时间字符串，如果差值为【0】，返回 【-】
	//返回时间格式： x分x秒
	math_A_B_str(a, b) {
		let _a = new Date(a)
		let _b = new Date(b)
		let _c = _b.getTime() - _a.getTime()
		if (_c == 0) {
			return '-'
		} else {
			return this.exam_viewTime_ch(_c / 1000)
		}
	},
	//计算两个时间的差值，返回时间字符串
	//返回时间值
	math_A_B_num(a, b) {
		let _a = new Date(a)
		let _b = new Date(b)
		let _c = _b.getTime() - _a.getTime()
		return _c
	},
	// 时间戳转时间
	timestampToTime(timestamp) {
		const date = new Date(timestamp);
		return date.toLocaleString();
	}
};

export {
	funcMap
};